export const FontSizeTitle = {
    small: "small",
    medium: "medium"
}